import { __decorate } from "tslib";
import { Injectable, ResourceActionFailed } from '@movecloser/front-core';
import { resolveFromStatus } from '@exception/connector-errors';
let AnonymousReportService = class AnonymousReportService {
    constructor(connector) {
        this.connector = connector;
    }
    async submit(reportData) {
        var _a;
        const payload = {
            message: reportData.message,
            ...(reportData.name && { name: reportData.name }),
            ...(reportData.email && { email: reportData.email }),
            ...(reportData.consent && { consent: reportData.consent })
        };
        const response = await this.connector.call('anonymousReports', 'create', {}, payload);
        if (!response.isSuccessful()) {
            throw new ResourceActionFailed(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to submit anonymous report', resolveFromStatus(response));
        }
    }
    async downloadPgpKey() {
        var _a;
        try {
            const response = await this.connector.call('anonymousReports', 'downloadPgpKey');
            if (response.isSuccessful()) {
                const blob = new Blob([response.data], { type: 'application/pgp-keys' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'anonymous-reports.pgp';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            else {
                throw new ResourceActionFailed(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to download PGP key', resolveFromStatus(response));
            }
        }
        catch (error) {
            throw new ResourceActionFailed('Failed to download PGP key', 500);
        }
    }
};
AnonymousReportService = __decorate([
    Injectable()
], AnonymousReportService);
export { AnonymousReportService };
